"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return function (input, start) {
    start = +start;
    try {
      return input.slice(start);
    } catch (err) {
      return [];
    }
  };
};

;


// WEBPACK FOOTER //
// ./client/components/filters/startFrom.js